require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./routing-2-add-new-dog-page.json") })
        }
      }, "path---routing-2-add-new-dog-page");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---routing-2-add-new-dog-page!./.cache/json/routing-2-add-new-dog-page.json
// module id = 407
// module chunks = 231608221292675